import angular from 'angular';
import cssVars from 'css-vars-ponyfill';
import to from 'await-to-js';
export class ThemeService {
    constructor(institutionHelper, colorService) {
        this.institutionHelper = institutionHelper;
        this.colorService = colorService;
    }
    getCssVariables(institution) {
        if (!institution || !institution.canStyle())
            return {};
        const rgbFront = this.colorService.toRGBValuesString(institution.frontColor);
        const sidebarContrastColor = this.colorService.pickSidebarContrast(institution);
        const contrastBack = this.colorService.pickContrastBack(institution);
        const contrastFront = this.colorService.pickContrast(institution.frontColor);
        const darkenFront = this.colorService.darken(institution.frontColor, 5);
        const darkestFront = this.colorService.darken(institution.frontColor, 7);
        const lightenFront = this.colorService.toRGBA(institution.frontColor, 0.64);
        const sidebarTextColor = institution.sidebarTextColor || '#8f97a4';
        const frontEqualsBgColor = institution.frontColor.toUpperCase() ===
            institution.backgroundColor.toUpperCase();
        return {
            '--main-color': institution.frontColor,
            '--main-color-rgb': rgbFront,
            '--main-darken-color': darkenFront,
            '--main-darkest-color': darkestFront,
            '--main-lighten-color': lightenFront,
            '--main-contrast-color': contrastBack,
            '--main-disabled-color': lightenFront,
            '--main-link-hover-color': this.colorService.darken(institution.frontColor, 15),
            '--sidebar-toggle-icon-color': institution.frontColor,
            '--sidebar-menu-text': sidebarTextColor,
            '--sidebar-menu-text-hover': sidebarContrastColor,
            '--sidebar-menu-icon-hover': sidebarContrastColor,
            '--sidebar-scroll-thumb-color': this.colorService.darken(institution.backgroundColor, 15),
            '--sidebar-menu-title-color': contrastBack,
            '--sidebar-menu-title-border-color': contrastBack,
            '--sidebar-patient-queue-color': contrastBack,
            '--sidebar-patient-queue-button-color': sidebarTextColor,
            '--sidebar-patient-queue-status-color': institution.backgroundColor,
            '--sidebar-start-call-button-color': contrastFront,
            '--sidebar-start-call-button-background-color': institution.frontColor,
            '--sidebar-precall-button-border': frontEqualsBgColor
                ? `1px solid ${sidebarContrastColor}`
                : 'none',
            '--sidebar-precall-link-color': frontEqualsBgColor
                ? sidebarContrastColor
                : 'var(--main-color)',
            '--sidebar-precall-link-hover-color': frontEqualsBgColor
                ? sidebarContrastColor
                : 'var(--main-link-hover-color)',
            '--tooltip-text-color': contrastFront,
            '--tooltip-background-color': institution.frontColor,
            '--institution-auth-text': institution.welcomeScreenText || darkenFront,
            '--institution-background-color': institution.backgroundColor,
            '--institution-auth-logo-background': institution.behindLogoColor || institution.frontColor,
            '--institution-background-image': institution.backgroundImage
                ? 'url(' + institution.backgroundImage + ')'
                : 'none',
            '--call-frames-action-color': this.colorService.toRGBA(institution.frontColor, 0.4),
        };
    }
    async applyCurrentInstitutionTheme() {
        let [err, institution] = await to(this.institutionHelper.getCurrentInstitution());
        if (err)
            institution = this.institutionHelper.nullInstitution;
        this.applyInstitutionTheme(institution);
    }
    applyInstitutionTheme(institution) {
        const variables = this.getCssVariables(institution);
        cssVars({
            variables,
            watch: true,
            onlyLegacy: true,
        });
        if (institution.favicon) {
            const link = document.querySelector("link[rel*='icon']");
            if (link)
                link.href = institution.favicon;
        }
    }
}
export default angular
    .module('doxy.common.services.themeService', [])
    .service('themeService', ThemeService).name;
